// Central data-testid registry
export const AUTH = {
  emailInput: "auth-email-input",
  passwordInput: "auth-password-input",
  loginBtn: "auth-login-btn",
  totpInput: "auth-totp-input",
  totpVerifyBtn: "auth-totp-verify-btn",
  totpSetupConfirmBtn: "auth-totp-setup-confirm-btn",
  changePasswordCurrent: "auth-change-password-current",
  changePasswordNew: "auth-change-password-new",
  changePasswordSubmit: "auth-change-password-submit",
  logoutBtn: "auth-logout-btn",
  errorMsg: "auth-error-msg",
};

export const NAV = {
  dashboard: "nav-dashboard",
  reports: "nav-reports",
  uploadReport: "nav-upload-report",
  generateReport: "nav-generate-report",
  admin: "nav-admin",
  profile: "nav-profile",
};

export const ADMIN = {
  tabUsers: "admin-tab-users",
  tabIps: "admin-tab-ips",
  tabDb: "admin-tab-db",
  tabSql: "admin-tab-sql",
  tabTeams: "admin-tab-teams",
  tabBrands: "admin-tab-brands",
  tabCurrencies: "admin-tab-currencies",
  newUserBtn: "admin-new-user-btn",
  newUserEmail: "admin-new-user-email",
  newUserPassword: "admin-new-user-password",
  newUserIsAdmin: "admin-new-user-is-admin",
  newUserSubmit: "admin-new-user-submit",
  suspendUserBtn: "admin-suspend-user-btn",
  deleteUserBtn: "admin-delete-user-btn",
  reset2faBtn: "admin-reset-2fa-btn",
  resetPwdBtn: "admin-reset-pwd-btn",
  newIpBtn: "admin-new-ip-btn",
  newIpInput: "admin-new-ip-input",
  newIpDesc: "admin-new-ip-desc",
  newIpSubmit: "admin-new-ip-submit",
  newDbBtn: "admin-new-db-btn",
  newDbSubmit: "admin-new-db-submit",
  testDbBtn: "admin-test-db-btn",
  sqlEditor: "admin-sql-editor",
  sqlRunBtn: "admin-sql-run-btn",
  sqlConnSelect: "admin-sql-conn-select",
  newTeamBtn: "admin-new-team-btn",
  newTeamName: "admin-new-team-name",
  newTeamSubmit: "admin-new-team-submit",
  editTeamBtn: "admin-edit-team-btn",
  newBrandId: "admin-new-brand-id",
  newBrandName: "admin-new-brand-name",
  newBrandCurrency: "admin-new-brand-currency",
  newBrandSubmit: "admin-new-brand-submit",
  editBrandBtn: "admin-edit-brand-btn",
  newCurrencyCode: "admin-new-currency-code",
  newCurrencySymbol: "admin-new-currency-symbol",
  newCurrencySubmit: "admin-new-currency-submit",
};

export const REPORTS = {
  uploadTeamSelect: "reports-upload-team-select",
  uploadMonthInput: "reports-upload-month-input",
  uploadFileInput: "reports-upload-file-input",
  uploadSubmit: "reports-upload-submit",
  uploadReportType: "reports-upload-report-type",
  generateConnSelect: "reports-generate-conn-select",
  generateTeamSelect: "reports-generate-team-select",
  generateMonthInput: "reports-generate-month-input",
  generateFileInput: "reports-generate-file-input",
  generateSubmit: "reports-generate-submit",
  generateReportType: "reports-generate-report-type",
  filterTeam: "reports-filter-team",
  filterMonth: "reports-filter-month",
  filterReportType: "reports-filter-report-type",
  aiGenerateBtn: "reports-ai-generate-btn",
};
